// extracted by mini-css-extract-plugin
export var filterIncDec = "_f1-0";
export var leftBorder = "_f1-1";
export var rightBorder = "_f1-2";
export var stringInput = "_f1-3";